import { render, staticRenderFns } from "./ProfilePictureDirect.vue?vue&type=template&id=fd6a6858&scoped=true"
import script from "./ProfilePictureDirect.vue?vue&type=script&lang=ts"
export * from "./ProfilePictureDirect.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePictureDirect.vue?vue&type=style&index=0&id=fd6a6858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6a6858",
  null
  
)

export default component.exports